import {
    audioExtensionsStr,
    cellExtensionsStr,
    docExtensionsStr,
    imageExtensionsStr,
    slideExtensionsStr,
    videoExtensionsStr
} from "./Common";

export function isOfficeFile(extension) {

    return isWordFile(extension) ||
        isCellFile(extension) ||
        isSlideFile(extension)
}

export function isAudioFile(extension) {

    return isFile(extension, audioExtensionsStr)
}

export function isVideoFile(extension) {

    return isFile(extension, videoExtensionsStr)
}

export function isImageFile(extension) {

    return isFile(extension, imageExtensionsStr)
}

export function isWordFile(extension) {

    return isFile(extension, docExtensionsStr)
}

export function isCellFile(extension) {

    return isFile(extension, cellExtensionsStr)
}

export function isSlideFile(extension) {

    return isFile(extension, slideExtensionsStr)
}

export function isFile(extension, extensionStr) {
    if (!extension) return !!extension
    return extensionStr.indexOf(extension) !== -1
}
